<template>
  <page-layout class="home">
    <template #topBar>
      <export-top-bar
        v-if="isPrint"
        :title="$t('myWorkspace.home')"
        :icons="[{ value: buildIcon('HomeOutlined_dark_grey'), size: 24 }]"
      />
      <page-top-bar
        v-else
        :breadcrumbs="breadcrumbs"
      >
        <template #actions>
          <m-dropdown
            v-if="shouldShowExportMenu"
            v-model:value="showActions"
            :title="$t('general.actions')"
            class="actions-menu"
          >
            <m-btn
              icon="ellipsis"
              hide-border
              fab
            />
            <template #overlay>
              <m-card
                no-padding
                list
                class="_export-actions-card"
              >
                <export-menu
                  :page="printablePage.homeGoals"
                  :saved-view="currentGoalView"
                  :allowed-export-formats="[printableExportFormat.image, printableExportFormat.pdf, printableExportFormat.csv]"
                  @export-requested="showActions = false"
                />
              </m-card>
            </template>
          </m-dropdown>
        </template>
      </page-top-bar>
    </template>
    <profile-body
      :user="loggedInUser"
    />
  </page-layout>
</template>

<script>
import ExportMenu from '@/components/export/ExportMenu.vue';
import ExportTopBar from '@/components/dashboard/ExportTopBar.vue';
import PageLayout from '@/components/page/PageLayout.vue';
import PageTopBar from '@/components/page/PageTopBar.vue';
import ProfileBody from '@/components/profile/ProfileBody.vue';
import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import usePrintMode from '@/composables/export/print-mode';
import { GOAL_VIEW, VIEW } from '@/route-params';
import { buildIcon } from 'shared/lib/icon';
import { getQueryParam } from '@/lib/route';
import { printableExportFormat, printablePage, viewType } from 'shared/constants.json';
import { useExportContext } from '@/composables/export/export-context';

export default {
  name: 'Home',
  setup() {
    const { loggedInUser } = useLoggedInUser();
    const { isPrint } = usePrintMode();
    const { currentView: currentGoalView } = useExportContext();
    return { loggedInUser, isPrint, currentGoalView, buildIcon };
  },
  components: { PageLayout, PageTopBar, ProfileBody, ExportTopBar, ExportMenu },
  data() {
    return {
      printablePage,
      printableExportFormat,
      showActions: false,
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          icons: [{ value: buildIcon('HomeOutlined_dark_grey') }],
          title: this.$t('myWorkspace.home'),
          disabled: true,
        },
      ];
    },
    currentView() {
      return getQueryParam(this.$route, VIEW);
    },
    isGoalView() {
      return this.currentView === GOAL_VIEW;
    },
    shouldShowExportMenu() {
      if (!this.isGoalView || !this.currentGoalView) {
        return false;
      }
      const currentViewType = this.currentGoalView.viewType;
      return currentViewType === viewType.list || currentViewType === viewType.cascade;
    },
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>
  ._export-actions-card {
    min-width: 15rem;
  }

  ._header {
    position: sticky;
    left: 0;
  }
</style>
